var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7876 54.6638C29.7876 53.1682 31 51.9558 32.4956 51.9558H56.8672C58.3628 51.9558 59.5752 53.1682 59.5752 54.6638C59.5752 56.1593 58.3628 57.3717 56.8672 57.3717H32.4956C31 57.3717 29.7876 56.1593 29.7876 54.6638Z",
    fill: "#FDBAA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7433 11.0077C47.9379 11.0077 47.1656 11.3276 46.5961 11.8971L13.277 45.2163L11.8455 50.942L17.5712 49.5105L50.8904 16.1913C51.1724 15.9094 51.396 15.5746 51.5486 15.2062C51.7012 14.8378 51.7798 14.443 51.7798 14.0442C51.7798 13.6455 51.7012 13.2506 51.5486 12.8822C51.396 12.5138 51.1724 12.1791 50.8904 11.8971C50.6084 11.6151 50.2737 11.3915 49.9053 11.2389C49.5369 11.0863 49.142 11.0077 48.7433 11.0077ZM42.7665 8.06745C44.3516 6.48232 46.5015 5.5918 48.7433 5.5918C49.8533 5.5918 50.9524 5.81043 51.9779 6.2352C53.0034 6.65997 53.9352 7.28257 54.72 8.06745C55.5049 8.85233 56.1275 9.78412 56.5523 10.8096C56.9771 11.8351 57.1957 12.9342 57.1957 14.0442C57.1957 15.1542 56.9771 16.2533 56.5523 17.2788C56.1275 18.3043 55.5049 19.2361 54.72 20.021L20.8705 53.8705C20.5234 54.2176 20.0886 54.4638 19.6124 54.5828L8.78057 57.2908C7.85776 57.5215 6.88158 57.2511 6.20897 56.5785C5.53637 55.9059 5.26598 54.9297 5.49668 54.0069L8.20465 43.1751C8.32368 42.6989 8.56989 42.2641 8.91694 41.917L42.7665 8.06745Z",
    fill: "#1B1F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLight);
export default __webpack_public_path__ + "static/media/brand-light.58bbc39ab850395c387fd944736daec1.svg";
export { ForwardRef as ReactComponent };